import { api } from './client';
import { TOKEN_KEY } from './authToken';
import { invalidateAuthSession, isTokenExpired } from './authSession';
export function getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
}
export function setStoredToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}
export async function clearStoredToken() {
    try {
        await api.post('/v1/auth/logout');
    }
    catch {
        // сеть/сервер недоступны - всё равно очищаем клиент
    }
    invalidateAuthSession();
}
export function isAuthenticated() {
    const token = getStoredToken();
    if (!token)
        return false;
    if (isTokenExpired(token)) {
        invalidateAuthSession();
        return false;
    }
    return true;
}
export async function login(data) {
    const res = await api.post('/v1/auth/login', data);
    return res.data;
}
export async function register(data) {
    const res = await api.post('/v1/auth/register', data);
    return res.data;
}
export async function verify(data) {
    const res = await api.post('/v1/auth/verify', data);
    return res.data;
}
/**
 * Запрашивает код восстановления пароля. Ответ одинаков и для незарегистрированного email:
 * по нему нельзя определить, существует ли учётная запись.
 */
export async function requestPasswordReset(email) {
    await api.post('/v1/auth/password-reset/request', { email });
}
export async function confirmPasswordReset(data) {
    await api.post('/v1/auth/password-reset/confirm', data);
}
/** Роли из payload JWT (без проверки подписи - только для UI, например редирект после входа). */
export function getRolesFromAccessToken(token) {
    try {
        const payload = token.split('.')[1];
        if (!payload)
            return [];
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const json = atob(base64);
        const decoded = JSON.parse(json);
        const roles = decoded.roles;
        return Array.isArray(roles) ? roles.filter((r) => typeof r === 'string') : [];
    }
    catch {
        return [];
    }
}
export function isStaffRole(roles) {
    return roles.includes('ADMIN') || roles.includes('ROOT');
}
/** UI-проверка роли из JWT. Сервер всё равно сверяет роль с БД на каждом запросе. */
export function isStaffAuthenticated() {
    const token = getStoredToken();
    if (!token || !isAuthenticated())
        return false;
    return isStaffRole(getRolesFromAccessToken(token));
}
